module.exports = __webpack_public_path__ + "static/media/jo.9f6b0e2f.png";